// ------------------------------------- Breach Wall Specific Types Below -------------------------------------

import { GridColumnProperty } from 'csstype'

export type BreachWallContentType =
    | 'default'
    | 'sport'
    | 'black-friday'
    | 'vanishing-cousins'
    | 'top-50-schools'
    | '50-off-afl-breach-screen'
    | '50-off-breach-discount' // to be used for most sales promotions
    | 'subs-campaign-eofy-weekend-digital'
    | 'business-pack'
    | 'sport-pack'
    | 'digital-only'
    | 'Puzzles'
    | 'Puzzles-increase'
    | 'puzzles-swg-30-off'
    | 'ePaper'
    | 'ePaper-price-increase'
    | 'default-annual-package'
    | 'summer-of-cricket'
    | 'afl-footy-lives-here-breach-screen'

export type BreachWallStyle =
    | 'default'
    | 'breach-190-year'
    | 'vanishing-cousins'
    | 'black-friday'
    | 'eofy'
    | 'summer-of-cricket'
    | 'footy-lives-here'

export type BreachBannerLayout = {
    topBannerText?: string
    mainBannerText?: string
    subBannerText?: string
    tncBannerText?: string
}

// ------------------------------------- Package Specific Types Below -------------------------------------

export type SubscriptionPackageButtonStyle =
    | 'default'
    | 'solid-blue'
    | 'transparent'
    | 'solid-red'
    | 'solid-yellow'
    | 'light-blue' // Used in the new 2026 SubscriptionPackageTheme's only
export type SubscriptionPackageTheme =
    | 'default'
    | 'red'
    | 'yellow'
    | 'vanishing-cousins'
    | 'west-blue'
    | 'optimise-blue'
    | 'afl-footy-design-2026'
    | 'redesign-2026'
export type SubscriptionPackageType = 'digital' | 'digitalprint'

export type RibbonOptions =
    | 'newDesignTag'
    | 'cornerDesignTag'
    | 'oldDesignTag'
    | 'bluePill'
    | 'bluePillLight'
    | 'freeDeliveryBluePill'

export interface SubscriptionPriceObject {
    price: string
    packagePath: string
    billingCycle?: string
    priceQualifier?: string
    googleSKU?: string
    cancellationMessage?: string
    // Will be appended to base benefits list if supplied
    additionalBenefits?: string[]
    // Package type to determine image and benefits to display
    packageType?: SubscriptionPackageType
    // Title of the subscription package
    packageTitle?: string

    // Pill options, which will be displayed with the radio qualifier
    ribbonTitle?: string
    ribbonOptions?: RibbonOptions

    // GA4 properties
    offerCode?: string
    rateCode: string
    weeklyPrice: number
    promoPrice?: number
    discount?: number
    quantity?: number
}

// Used to position subscription packages in a grid layout if supplied
export type SubscriptionColumnPosition = GridColumnProperty

interface BaseSubscriptionPackage {
    heading: string
    subHeading?: string
    ribbonTitle?: string
    ribbonOptions?: RibbonOptions
    packageType?: SubscriptionPackageType
    packageTheme?: SubscriptionPackageTheme
    // Properties for ga4 event - ACQ-17
    benefitOverride?: string[]
    additionalBenefits?: string[]
    buttonStyle?: SubscriptionPackageButtonStyle

    // Optional column position for subscription grid layouts
    columnPosition?: {
        mobile: SubscriptionColumnPosition
        desktop: SubscriptionColumnPosition
    }
    // Indicates if this subscription package has the recommended banner (generally only one per subscription)
    isRecommended?: boolean
}

// Overall type to provide subscription package data across the board.
export type SubscriptionPackageOptions =
    | ISingleSubscriptionPackage
    | IRadioSubscriptionPackage

export interface IRadioSubscriptionPackage extends BaseSubscriptionPackage {
    type: 'radio-list-subscriptions'
    prices: SubscriptionPriceObject[]
}
export interface ISingleSubscriptionPackage
    extends SubscriptionPriceObject,
        BaseSubscriptionPackage {
    type: 'single-subscription'
    originalPrice?: string
}

export const mapSubscriptionPackagesToFlatList = (
    packages: SubscriptionPackageOptions[],
): ISingleSubscriptionPackage[] => {
    return packages.flatMap((pkg) => {
        if (pkg.type === 'single-subscription') {
            return pkg
        } else {
            return pkg.prices.map((radioPkg) => {
                return {
                    ...pkg,
                    ...radioPkg,
                    type: 'single-subscription',
                } as ISingleSubscriptionPackage
            })
        }
    })
}
